var _rect, _rect2, _path, _path2, _path3, _g, _g2, _g3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 480,
    viewBox: "0 0 343 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 480,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 343,
    height: 343,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.0864 129C39.5034 156.68 21 196.168 21 240C21 283.832 39.5034 323.32 69.0864 351M274.544 129C304.127 156.68 322.63 196.168 322.63 240C322.63 283.832 304.127 323.32 274.544 351",
    stroke: "#FF6666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.3448 147.098C61.7318 170.265 46.337 203.314 46.337 240C46.337 276.685 61.7318 309.735 86.3448 332.902M257.286 147.098C281.899 170.265 297.293 203.314 297.293 240C297.293 276.685 281.899 309.735 257.286 332.902",
    stroke: "#FF6666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.891 170.021C88.1942 187.472 76.5 212.366 76.5 240C76.5 267.633 88.1942 292.527 106.891 309.978M236.74 170.021C255.436 187.472 267.13 212.366 267.13 240C267.13 267.633 255.436 292.527 236.74 309.978",
    stroke: "#FF6666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_4789_33466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.136 199.166L182.769 177.967C178.723 176.498 176.7 175.763 174.623 175.472C172.78 175.214 170.91 175.214 169.067 175.472C166.99 175.763 164.967 176.498 160.921 177.967L102.548 199.166L171.845 224.338L241.136 199.166Z",
    fill: "url(#paint0_linear_4789_33466)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.598 178.437L239.672 199.166L171.845 223.806L104.013 199.166L161.092 178.437C165.157 176.961 167.123 176.249 169.137 175.967C170.933 175.715 172.757 175.715 174.553 175.967C176.567 176.25 178.533 176.961 182.598 178.437Z",
    stroke: "url(#paint1_linear_4789_33466)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_4789_33466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.844 224.338V309.194L232.706 287.085C235.743 285.982 237.262 285.43 238.382 284.458C239.371 283.598 240.134 282.509 240.604 281.286C241.136 279.901 241.136 278.286 241.136 275.054V199.166L171.844 224.338Z",
    fill: "url(#paint2_linear_4789_33466)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.636 199.88V275.054C240.636 278.327 240.628 279.829 240.137 281.107C239.697 282.253 238.981 283.275 238.054 284.08C237.021 284.977 235.611 285.498 232.535 286.615L172.344 308.481V224.688L240.636 199.88Z",
    stroke: "url(#paint3_linear_4789_33466)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_4789_33466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.845 224.338L102.548 199.166V275.054C102.548 278.285 102.548 279.901 103.08 281.286C103.55 282.509 104.313 283.598 105.302 284.458C106.422 285.43 107.941 285.982 110.978 287.085L171.845 309.194V224.338Z",
    fill: "url(#paint4_linear_4789_33466)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.345 308.481L111.148 286.615C108.072 285.498 106.663 284.977 105.63 284.08C104.702 283.274 103.987 282.253 103.547 281.107C103.056 279.829 103.048 278.327 103.048 275.054V199.88L171.345 224.688V308.481Z",
    stroke: "url(#paint5_linear_4789_33466)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 322L251 158",
    stroke: "#FF6666",
    strokeWidth: 6.07229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_4789_33466",
    x: 82.5482,
    y: 155.278,
    width: 178.588,
    height: 89.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4789_33466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_4789_33466",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4789_33466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_4789_33466",
    x: 151.844,
    y: 179.166,
    width: 109.291,
    height: 150.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4789_33466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_4789_33466",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4789_33466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_4789_33466",
    x: 82.5479,
    y: 179.166,
    width: 109.297,
    height: 150.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4789_33466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_4789_33466",
    result: "effect2_dropShadow_4789_33466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4789_33466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4789_33466",
    x1: 171.842,
    y1: 189.6,
    x2: 171.842,
    y2: 224.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4789_33466",
    x1: 171.842,
    y1: 174,
    x2: 171.842,
    y2: 224.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4789_33466",
    x1: 206.49,
    y1: 233.266,
    x2: 206.49,
    y2: 309.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4789_33466",
    x1: 206.49,
    y1: 199.166,
    x2: 206.49,
    y2: 309.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4789_33466",
    x1: 137.196,
    y1: 233.266,
    x2: 137.196,
    y2: 309.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4789_33466",
    x1: 137.196,
    y1: 199.166,
    x2: 137.196,
    y2: 309.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6666",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b9af615a357e5bbf7e1262f2e8c33fef.svg";
export { ForwardRef as ReactComponent };